'use client';

import { useTranslation } from '@/context/LanguageContext';
import styles from './page.module.scss';

export default function TermsContent() {
  const { t } = useTranslation();

  const sections = [
    { title: t.terms.companyTitle, body: t.terms.companyBody },
    { title: t.terms.pricesTitle, body: t.terms.pricesBody },
    {
      title: t.terms.deliveryTitle,
      body: [t.terms.deliveryBodyDK, t.terms.deliveryBodyEU, t.terms.deliveryBodyGeneral].join('\n\n'),
    },
    {
      title: t.terms.returnTitle,
      body: [t.terms.returnBody, t.terms.returnHow, t.terms.returnException].join('\n\n'),
    },
    { title: t.terms.subscriptionTitle, body: t.terms.subscriptionBody },
    { title: t.terms.complaintsTitle, body: t.terms.complaintsBody },
    { title: t.terms.disputeTitle, body: t.terms.disputeBody },
    { title: t.terms.personalDataTitle, body: t.terms.personalDataBody },
    { title: t.terms.cookiesTitle, body: t.terms.cookiesBody },
    { title: t.terms.changesTitle, body: t.terms.changesBody },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h1>{t.terms.title}</h1>
          <p className={styles.updated}>{t.terms.lastUpdated}</p>
        </header>

        <div className={styles.content}>
          {sections.map((section, i) => (
            <section key={i} className={styles.section}>
              <h2>{section.title}</h2>
              {section.body.split('\n\n').map((paragraph, j) => (
                <p key={j}>
                  {paragraph.split('\n').map((line, k, arr) => (
                    <span key={k}>
                      {line}
                      {k < arr.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              ))}
            </section>
          ))}

          <section className={styles.contact}>
            <h2>{t.terms.contactTitle}</h2>
            <p>{t.terms.contactBody}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
